import { render } from "./PostalEntry.vue?vue&type=template&id=4068f130&scoped=true&ts=true"
import script from "./PostalEntry.vue?vue&type=script&lang=ts"
export * from "./PostalEntry.vue?vue&type=script&lang=ts"

import "./PostalEntry.vue?vue&type=style&index=0&id=4068f130&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4068f130"]])

export default __exports__